import * as types from "./actionTypes"

export function fetchGeneralPlacementsRequests(request) {
    return {
        type: types.FETCH_ALL_REQUESTS,
        payload: request,
    }
}
export function fetchGeneralPlacementsRequestsSuccess(request) {
    return {
        type: types.FETCH_ALL_REQUESTS_SUCCESS,
        payload: request,
    }
}
export function fetchGeneralPlacementsRequestsFailure() {
    return {
        type: types.FETCH_ALL_REQUESTS_FAILURE,
    }
}
export function fetchGeneralPlacemetRequestDetails(data) {
    return {
        type: types.FETCH_REQUEST_DETAILS,
        payload: data,
    }
}
export function fetchGeneralPlacemetAllDetails(data) {
    return {
        type: types.FETCH_REQUEST_ALL_DETAILS,
        payload: data,
    }
}
export function fetchGeneralPlacemetRequestDetailsSuccess(data) {
    return {
        type: types.FETCH_REQUEST_DETAILS_SUCCESS,
        payload: {
            requestsData: data.requestsData,
            requestDetails: data.requestDetails,
        },
    }
}

export function fetchGeneralPlacemetRequestDetailsFailure() {
    return {
        type: types.FETCH_REQUEST_DETAILS_FAILURE,
    }
}
export function createNewRequests(data) {
    return {
        type: types.CREATE_NEW_REQUESTS,
        payload: data,
    }
}
export function createNewRequestsSuccess(data) {
    return {
        type: types.CREATE_NEW_REQUESTS_SUCCESS,
        payload: data,
    }
}
export function createNewRequestsFailure() {
    return {
        type: types.CREATE_NEW_REQUESTS_FAILURE,
    }
}

export function createNewRequestsReset() {
    return {
        type: types.CREATE_NEW_REQUESTS_RESET,
    }
}

export function fetchDetailOptions() {
    return {
        type: types.FETCH_DETAILS_VALUE_OPTIONS,
    }
}

export function fetchDetailOptionsSuccess(data) {
    return {
        type: types.FETCH_DETAILS_VALUE_OPTIONS_SUCCESS,
        payload: data,
    }
}

export function fetchDetailOptionsfailure() {
    return {
        type: types.FETCH_DETAILS_VALUE_OPTIONS_FAILURE,
    }
}

export function SendEmailNotification(data) {
    return {
        type: types.SEND_EMAIL_NOTIFICATION,
        payload: data,
    }
}

export function SendEmailNotificationSuccess() {
    return {
        type: types.SEND_EMAIL_NOTIFICATION_SUCCESS,
    }
}

export function ClearStateData() {
    return {
        type: types.CLEAR_STATE_DATA,
    }
}
